/**
 * Implements closing and opening the mobile menu.
 */
(() => {
    let menu = document.querySelector('.js-mobile-menu');
    let toggles = document.querySelectorAll('.js-mobile-menu-toggle');
    let backdrops = document.querySelectorAll('.js-mobile-menu-backdrop');
    const animationDuration = 200;

    if (!menu || !toggles.length) {
        return;
    }

    /**
     * A wrapper function; closes the menu using mobile menu tools.
     *
     * @param {*} toggle (Optional) The toggle that triggered the close
     */
    function closeMenu(toggle = false) {
        H_Tools.mobilemenu.closeMenu(menu, toggles, animationDuration, toggle);
    }

    function handleToggle(e) {
        // console.log('Mobile menu toggle clicked...');

        let toggle = e.target.closest('.js-mobile-menu-toggle');

        if (document.documentElement.classList.contains('-is-active-menu')) {
            closeMenu(toggle);
        } else {
            H_Tools.mobilemenu.openMenu(toggles);
        }
    }

    function initOutsideFocus(el) {
        H_Tools.mobilemenu.makeOutsideFocusCloseMenu(
            menu,
            toggles,
            el,
            animationDuration
        );
    }

    // close mobile menu when anchor links are clicked
    menu.querySelectorAll('a[href*="#"]').forEach((link) => {
        if (link.getAttribute('href') === '#') {
            return;
        }
        link.addEventListener('click', closeMenu);
    });

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', handleToggle);
    });

    backdrops.forEach((backdrop) => {
        backdrop.addEventListener('click', closeMenu);
    });

    // close mobile menu when the ESC key is pressed
    document.addEventListener('keydown', (event) => {
        if (H_Tools.key.isEscape(event)) {
            closeMenu();
            H_Tools.mobilemenu.focusOpeningToggle(menu);
        }
    });

    initOutsideFocus(document.querySelector('.js-site-header'));
    initOutsideFocus(document.querySelector('.js-site-supplementary'));
    initOutsideFocus(document.querySelector('.js-site-modal'));
    initOutsideFocus(document.querySelector('.js-site-main'));
})();
